import {SvgIcon} from "@mui/material";

export default function ActuatorIcon({sx}) {

    return (
        <SvgIcon sx={sx} fontSize={"large"} viewBox="0 -4000 10000 3000">
            <path transform="scale(2, -2) translate(0, -880)" d={"M624 3549 c-17 -19 -19 -41 -22 -230 l-3 -209 -40 0 -39 0 0 59 c0\n" +
                "44 -5 65 -21 85 l-20 26 -173 0 c-167 0 -173 -1 -194 -23 l-22 -23 0 -822 c0\n" +
                "-809 0 -822 20 -842 18 -18 33 -20 194 -20 l175 0 20 26 c15 20 21 41 21 80\n" +
                "l0 54 1110 0 1110 0 0 -60 c0 -98 5 -100 213 -100 164 0 175 1 193 21 17 19\n" +
                "19 42 22 265 l3 244 369 0 370 0 0 -81 c0 -77 10 -115 34 -131 6 -4 146 -8\n" +
                "311 -8 333 0 369 5 479 63 75 39 181 143 224 218 40 71 72 193 72 273 -1 256\n" +
                "-192 494 -438 545 -31 7 -172 11 -347 11 l-294 0 -20 -26 c-17 -22 -21 -41\n" +
                "-21 -110 l0 -84 -370 0 -369 0 -3 246 c-4 310 16 284 -217 284 -204 0 -204 0\n" +
                "-211 -97 -4 -60 -7 -68 -25 -68 -19 0 -20 8 -25 213 -5 197 -7 215 -24 228\n" +
                "-16 11 -63 14 -222 14 l-203 0 -20 -26 c-20 -25 -21 -39 -21 -230 l0 -204\n" +
                "-552 2 -553 3 -3 209 c-2 178 -5 213 -19 228 -15 16 -36 18 -223 18 -198 0\n" +
                "-208 -1 -226 -21z m326 -279 l0 -161 -102 3 -103 3 -3 158 -3 157 106 0 105 0\n" +
                "0 -160z m1600 0 l0 -161 -102 3 -103 3 -3 158 -3 157 106 0 105 0 0 -160z\n" +
                "m-2170 -855 l0 -725 -75 0 -75 0 0 725 0 725 75 0 75 0 0 -725z m2650 0 l0\n" +
                "-725 -75 0 -75 0 0 725 0 725 75 0 75 0 0 -725z m-292 -2 l-3 -558 -1107 -3\n" +
                "-1108 -2 0 560 0 560 1110 0 1110 0 -2 -557z m1864 396 c173 -58 288 -219 288\n" +
                "-402 -1 -146 -101 -302 -239 -370 l-66 -32 -267 -3 -268 -3 0 415 0 416 245 0\n" +
                "c222 0 252 -2 307 -21z m-692 -394 l0 -195 -370 0 -370 0 0 195 0 195 370 0\n" +
                "370 0 0 -195z\"/>\n" +
                "<path d=\"M4390 2711 c-136 -42 -223 -158 -223 -297 0 -92 33 -164 104 -228\n" +
                "194 -175 504 -34 503 229 0 51 -6 84 -23 123 -32 70 -115 146 -183 167 -54 16\n" +
                "-136 18 -178 6z m159 -151 c147 -74 101 -294 -64 -308 -116 -10 -203 92 -174\n" +
                "203 27 103 143 154 238 105z'\n"}/>
        </SvgIcon>
    )

}
